export {default} from './CustomTable';
